import { useSite } from "@/lib/content";
import { useSeo } from "@/lib/seo";
import Hero from "@/pages/home/Hero";
import Intro from "@/pages/home/Intro";
import Areas from "@/pages/home/Areas";
import WidePhoto from "@/pages/home/WidePhoto";
import VisitSummary from "@/pages/home/VisitSummary";
import ContactCta from "@/pages/home/ContactCta";
import Notices from "@/components/Notices";
import TicketCta from "@/components/booking/TicketCta";

export default function Home() {
  useSeo("home");
  const { content, isPreview } = useSite();
  return (
    <div data-testid="home-page">
      <Hero content={content} isPreview={isPreview} />
      <Notices />
      <Intro />
      <Areas content={content} isPreview={isPreview} />
      <WidePhoto content={content} isPreview={isPreview} />
      <TicketCta testId="home-ticket-cta" className="py-16" />
      <VisitSummary content={content} isPreview={isPreview} />
      <ContactCta content={content} isPreview={isPreview} />
    </div>
  );
}
